<template>
  <div class="content">
    <div class="home">
      <div class="heard">

        <el-form label-width="120px" label-height="60px">
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item label="供应商名称">
                <el-input style="width: 100%;" v-model="querySearch.condition.supplierName"
                  placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="商品名称">
                <el-input style="width: 100%;" v-model="querySearch.condition.productName" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="商品审核状态">
                <el-select style="width: 100%;" v-model="querySearch.condition.chackStatus" placeholder="请选择">
                  <el-option label="全部" :value="3"></el-option>
                  <el-option label="待审核" :value="0"></el-option>
                  <el-option label="已审核" :value="1"></el-option>
                  <el-option label="已拒绝" :value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="创建时间">
                <el-date-picker style="width: 100%;" @change="changeTime" v-model="forceTime" type="datetimerange"
                  range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['', '23:59:59']"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="16" style="display: flex;justify-content: flex-end;">
              <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="getProductList">查询</el-button>
                <el-button type="info" icon="el-icon-refresh" @click="reset">重置</el-button>
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>
      </div>
      <div class="main">
        <div class="main-table" style="position: relative">
          <el-table :data="tableList" style="width: 100%" height="calc(100vh - 400px)" border>
            <el-table-column type="selection" width="100" align="center">
            </el-table-column>
            <el-table-column label="序号" type="index" width="80" align="center">
            </el-table-column>
            <el-table-column prop="productName" label="商品名称" width="150" align="center">
            </el-table-column>

            <el-table-column label="商品照片" align="center" width="150">
              <!-- <template slot-scope="scope">{{ scope.row.createTime }}</template> -->
              <template slot-scope="scope">
                <el-image style="width: 100px; height: 100px" :src="scope.row.listImg"
                  :preview-src-list="[scope.row.listImg]">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </template>
            </el-table-column>
            <el-table-column prop="categoryFirstName" label="一级分类" width="150" align="center">
            </el-table-column>
            <el-table-column prop="categorySecondName" label="二级分类" width="150" align="center">
            </el-table-column>
            <el-table-column prop="sellPrice" label="商品价格" align="center"></el-table-column>
            <el-table-column prop="supplierName" label="供应商名称" width="100" align="center">
            </el-table-column>

            <el-table-column prop="chackStatus" label="商品审核状态" width="120" align="center">
              <template slot-scope="{ row }">
                <el-button v-if="row.chackStatus == 0" type="info" plain>待审核</el-button>
                <el-button v-if="row.chackStatus == 1" type="success" plain>已审核</el-button>
                <el-button v-if="row.chackStatus == 2" type="danger" plain>已拒绝</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="productStatus" label="商品状态" width="120" align="center">
              <template slot-scope="{ row }">
                <el-button v-if="row.productStatus == 1" type="success" plain>销售中</el-button>
                <el-button v-if="row.productStatus == 2" type="danger" plain>已下架</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="160" align="center">
            </el-table-column>

            <el-table-column prop="chackStatus" label="操作" width="120" align="center" fixed="right">
              <template slot-scope="{ row }">
                <div>
                  <el-button v-if="row.chackStatus == 0" class="item-elbtn" type="text" size="small"
                    @click="goAduit(row)">审核</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="page">
          <el-pagination background layout="prev, pager, next" :total="count" :page-size="10"
            @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import productChildren from "./components/productChildren.vue";
export default {
  components: {
    // productChildren
  },
  data () {
    return {
      forceTime: [],
      querySearch: {
        condition: {
          startTime: '',
          endTime: '',
          productName: '',
          supplierName: '',
          chackStatus: 3,
          supplierFlag: 1
        },
        count: 0,
        currPage: 1,
        pageCount: 0,
        pageSize: 10
      },
      tableList: [],
      count: 0
    }
  },
  created () {
    this.getProductList()
  },
  methods: {
    changeTime (data) {
      if (data) {
        this.querySearch.condition.startTime = data[0]
        this.querySearch.condition.endTime = data[1]
      } else {
        this.querySearch.condition.startTime = ''
        this.querySearch.condition.endTime = ''
      }
      this.getProductList()
    },
    reset () {
      this.querySearch.condition.startTime = ''
      this.querySearch.condition.endTime = ''
      this.forceTime = []
      this.querySearch.condition.productName = ''
      this.querySearch.condition.supplierName = ''
      this.querySearch.condition.chackStatus = 3
      this.querySearch.currPage = 1
      this.querySearch.pageSize = 10
      this.getProductList()
    },
    handleCurrentChange (val) {
      this.querySearch.currPage = val
      this.getProductList()
    },
    getProductList () {
      let _this = this
      this.$http.post('/product/list', _this.querySearch).then(function (res) {
        let { code, data } = res.data
        if (code === 200) {
          _this.tableList = data.data
          _this.count = data.count
        }
      })
    },
    goAduit (val) {
      this.$router.push('/aduitProduct?productCode=' + val.productCode)
    }
  }
}
</script>
<style lang="less" scoped>
.content {
  height: 100% !important;

  .home {
    height: 100% !important;
    display: flex;
    flex-direction: column;
    background-color: #eef1f6;
    padding: 10px;
    box-sizing: border-box;
  }

  .heard {
    background-color: #fff;
    height: auto;
    padding: 15px;

    .item-col {
      display: flex;
      align-items: center;
      margin-bottom: 18px;

      .label {
        width: fit-content;
        margin-right: 10px;
      }

      div {
        flex: 1;
      }
    }
  }

  .main {
    margin-top: 20px;
    flex: 1;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    padding: 15px;

    .main-table {
      flex: 1;
      overflow: hidden;
    }

    .page {
      display: flex;
      justify-content: flex-end;
    }
  }
}

/deep/ .el-tabs__nav-wrap::after {
  position: static !important;
}

/deep/ .el-tabs__active-bar {
  background-color: transparent !important;
}

/deep/ .el-tabs__nav.is-top {
  width: 100%;
  padding: 10px 0;
  display: flex;
  justify-content: space-around;
  background-color: #dff0f9;
  overflow-y: auto;
}

/deep/ .item-elbtn {
  margin-left: 0;
  padding: 0 2px;
}
</style>
